import { StateNode, ProcessConfig } from '../types';
import { openTransaction } from '../stateDefinitionOptions';

export function readyToScan(options: ProcessConfig): StateNode {
  const always: any = [
    { cond: 'isTransactionNew', actions: ['assignInProgressState', 'save'] },
    { cond: 'isTransactionComplete', target: 'complete' },
  ];

  if (!openTransaction(options)) {
    always.push({ cond: 'isTransactionFulfilled', target: 'transactionBeforeComplete' });
  }

  return {
    entry: ['assignUser'],
    exit: ['clearCurrentCode'],
    always,
    on: {
      ENTER_EAN: { target: 'eanEntered' },
      ENTER_CODE: { target: 'codeEntered' },
      COMPLETE: { target: 'transactionBeforeComplete' },
    },
  };
}
